export default __webpack_public_path__ + "c056e6485bdfd6a4819d842eb3ec6bf6.svg";